module.exports = __webpack_public_path__ + "media/images/flower_copper-82ab1b46ba419874a7957d29d270abaf.svg";